import { z } from 'zod'
import type { BlockscoutClient } from './client'

type GetBlockNumberByTimestampParameters = {
  client: BlockscoutClient
  /** Unix timestamp in seconds */
  timestamp: number
  closest?: 'before' | 'after'
  headers?: Record<string, string>
}

const resultSchema = z.object({
  blockNumber: z.string().regex(/^\d+$/).transform(Number),
})

/** {@link https://docs.blockscout.com/developer-support/api/rpc-endpoints/block#get-block-number-by-time-stamp} */
export const getBlockNumberByTimestamp = async ({
  client,
  timestamp,
  closest = 'before',
  headers,
}: GetBlockNumberByTimestampParameters) => {
  const result = await client.get({
    path: '',
    query: {
      module: 'block',
      action: 'getblocknobytime',
      timestamp: timestamp.toString(),
      closest,
    },
    resultSchema,
    headers,
  })
  return result.blockNumber
}
